import React, { Component } from "react";
import HelperClass from "../../config/helperClass";
const auth = new HelperClass();

class ChatWidget extends Component {
  componentDidMount() {
    // Prevent multiple injections
    if (document.getElementById("ze-snippet")) return;

    const script = document.createElement("script");
    script.id = "ze-snippet";
    script.src =
      "https://static.zdassets.com/ekr/snippet.js?key=44217caf-65af-4120-b9c9-c30cd4ced535";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      // console.log("Zendesk widget loaded");

      // Example: set user info (if logged in)
      if (auth.getEmail()) {
        window.zE("webWidget", "identify", {
          name: auth.getName(),
          email: auth.getEmail(),
        });
      }
    };
  }

  render() {
    return null; // No UI, just loads the widget
  }
}

export default ChatWidget;
